/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Invoice_Tags_ChargeInputs */

const en_admin_dashboard_invoice_tags_charge = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_ChargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charges`)
};

const de_admin_dashboard_invoice_tags_charge = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_ChargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebühren`)
};

const es_admin_dashboard_invoice_tags_charge = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_ChargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargos`)
};

const fr_admin_dashboard_invoice_tags_charge = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_ChargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frais`)
};

const nl_admin_dashboard_invoice_tags_charge = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_ChargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kosten`)
};

const it_admin_dashboard_invoice_tags_charge = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_ChargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Addebiti`)
};

const pt_br2_admin_dashboard_invoice_tags_charge = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_ChargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cobranças`)
};

const pl_admin_dashboard_invoice_tags_charge = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_ChargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opłaty`)
};

const hu_admin_dashboard_invoice_tags_charge = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_ChargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Díjak`)
};

const ro_admin_dashboard_invoice_tags_charge = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_ChargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taxe`)
};

/**
* | output |
* | --- |
* | "Charges" |
*
* @param {Admin_Dashboard_Invoice_Tags_ChargeInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_invoice_tags_charge = /** @type {((inputs?: Admin_Dashboard_Invoice_Tags_ChargeInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Invoice_Tags_ChargeInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_invoice_tags_charge(inputs)
	if (locale === "de") return de_admin_dashboard_invoice_tags_charge(inputs)
	if (locale === "es") return es_admin_dashboard_invoice_tags_charge(inputs)
	if (locale === "fr") return fr_admin_dashboard_invoice_tags_charge(inputs)
	if (locale === "nl") return nl_admin_dashboard_invoice_tags_charge(inputs)
	if (locale === "it") return it_admin_dashboard_invoice_tags_charge(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_invoice_tags_charge(inputs)
	if (locale === "pl") return pl_admin_dashboard_invoice_tags_charge(inputs)
	if (locale === "hu") return hu_admin_dashboard_invoice_tags_charge(inputs)
	return ro_admin_dashboard_invoice_tags_charge(inputs)
});
export { admin_dashboard_invoice_tags_charge as "admin.dashboard.invoice_tags.charge" }